<template>
  <v-dialog v-model="showDialog" max-width="320px" persistent>
    <v-card flat>
      <v-icon class="close" @click.prevent="showDialog = false; $emit('close')">$sl-close</v-icon>
      <h2>{{$t('ebook.change-workplace')}}</h2>
      <workplaces-list
        :workplaces="workplaceList"
        @item-click="clickWorkplace($event)"
        actionType="select"
        withSearch
        flat
        :model="workplaceId"
      ></workplaces-list>
      <div class="d-flex justify-space-between mt-6">
        <ActionButton
          :block="false"
          type="application"
          actionIcon="$sl-cancel"
          @click="showDialog = false; $emit('close')"
        >{{ $t('labels.cancel') }}</ActionButton>
        <ActionButton
          :block="false"
          @click="linkWorkplace"
          actionIcon="$sl-workplace"
          :isDisabled="isImitatingUser()"
        >{{$t('labels.change')}}</ActionButton>
      </div>
      <v-card-text>{{$t('ebook.change-workplace-text')}}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import ActionButton from '@/components/Common/ActionButton'
import WorkplacesList from '@/components/Common/Workplace/WorkplacesList'
import filter from 'lodash/filter'
import find from 'lodash/find'

// @group Common
// Styled SelectInstructorModal component
export default {
  name: 'SelectWorkplaceModal',
  props: {
    //is it showed
    show: false,

    //has company id
    companyId: {
      // `'Integer'`
      type: Number,
      // The default value is: `null`
      default: null
    },
    //has workplace
    workplace: {
      // `'Object'`
      type: Object,
      default: null
      // The default value is: `null`
    }
  },

  data: () => ({
    showDialog: false,
    workplaceId: 0,
    companyWorkplaces: []
  }),

  components: {
    ActionButton,
    WorkplacesList,
  },

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser']),
    workplaceList() {
      return filter(
        this.companyWorkplaces.map(o => {
          return {
            id: o.id,
            name: o.name,
            postalAddress1: o.postalAddress1,
            postalZip: o.postalZip,
            postalCity: o.postalCity
          }
        }),
        function (o) {
          return o.id !== null
        }
      )
    }
  },

  created() {
    this.init()
  },

  watch: {
    show(val) {
      this.showDialog = val
      this.init()
      // this.workplace = []
    },
    companyId() {
      this.init()
    }
  },

  methods: {
    /**
     * @vuese
     * Used to get workplaces
     * @arg The argument is an integer representing company id
     */
    init() {
      let id = null

      this.companyId != null ? (id = this.companyId) : (id = this.$route.params.id)
      this.workplaceId = this.workplace.id

      API.getWorkplaces(Number(id))
        .then(res => {
          this.companyWorkplaces = res.data
          //this.workplace = this.companyWorkplaces.map(o => o.id)
          //this.workplace[0] = {id: 1}
        })
        .catch(err => {
          console.log(err)
        })
    },
    check: function (e) {
      e.cancelBubble = true
    },
    linkWorkplace() {
      const p = find(this.companyWorkplaces, ['id', this.workplaceId])
      // Fire linked with workplace object
      // @arg The argument is a object
      this.$emit('linked', p)
    },
    clickWorkplace({ id }) {
      this.workplaceId = id;
    },
  }
}
</script>

